module.exports = __webpack_public_path__ + "img/Consultation.37c8af52.svg";